import React from "react";
import styled from "styled-components";

export const labels = {
    dateType: "Date type"
};

const dateType = () => ({
    header: <Heading>Date Filtering Options</Heading>,
    body: (
        <>
            <Paragraph>
                <b>Effective date</b> - Filters transactions based on the effective date on the
                transaction event (i.e. when the transaction event has become effective on the
                account).
            </Paragraph>
            <Paragraph>
                <b>Processed date</b> - Filters transactions based on the processed date on the
                transaction event (i.e. when the transaction event was instructed).
            </Paragraph>
            <Paragraph>
                <b>Execution date</b> - Filters transactions based on the effective date on any
                underlying investment transactions from a transaction event, for example, the
                purchase of individual funds following a regular payment. If none exist within the
                date range, filters will be based on the effective date of the transaction event.
            </Paragraph>
            <Paragraph>
                <b>Reporting date</b> - Filters the transactions based on the reporting date when
                the customer will receive the money in their bank account or the date that the
                transaction is reported to HMRC.
            </Paragraph>
        </>
    )
});

const descriptions = {
    [labels.dateType]: dateType
};

export const getDescription = (label, additionalData = {}) => descriptions[label](additionalData);

const Heading = styled.h1`
    font-size: 1.25rem;
`;

const Paragraph = styled.p`
    font-size: 1rem;
    text-align: justify;
`;
